/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { TextField } from 'formik-mui';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { getAllGetchkdUsers } from '../../../../../../store/reducers/getchkdUser/getchkdUserAction';


const HashicorpUserCreationForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const dispatch = useDispatch();
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(getAllGetchkdUsers()).unwrap();

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [dispatch]);


    return (


        <Form>

            <Grid container spacing={4}><Grid item xs={12} md={12} sm={12}>

                {values.hasOwnProperty("userName") &&
                    <FormControl fullWidth error={Boolean(touched.userName && errors.userName)}>
                        <InputLabel htmlFor="outlined-status">Getchkd User</InputLabel>
                        <Select
                            value={values.userName}
                            variant="outlined"
                            name="userName"
                            label="Getchkd User"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((item) => (
                                <MenuItem value={item.getChkdID}>
                                    {item.email}
                                </MenuItem>
                            ))}


                        </Select>
                        {errors.userName && <FormHelperText style={{ color: "red" }} >{errors.userName}</FormHelperText>}

                    </FormControl>
                }

                {values.hasOwnProperty("userPass") &&
                    <Grid container spacing={2}>

                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                <Field
                                    name="userPass"
                                    label="Password"
                                    type={showPassword ? "text" : 'password'}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    value={values.userPass}
                                    component={TextField}
                                    InputProps={{

                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setShowPassword(!showPassword) }}
                                                >
                                                    {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                <Field
                                    value={values.confirmPassword}
                                    component={TextField}

                                    name="confirmPassword"
                                    label="Confirm Password"
                                    type={showPassword ? "text" : 'password'}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{

                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setShowPassword(!showPassword) }}
                                                >
                                                    {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                }
                {values.hasOwnProperty("policyName") &&
 
                      
                       <FormControl fullWidth error={Boolean(touched.policyName && errors.policyName)}>
                        <InputLabel htmlFor="outlined-status">Policy Name</InputLabel>
                        <Select
                            value={values.policyName}
                            variant="outlined"
                            name="policyName"
                            label="Policy Name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                                 <MenuItem value="userpass">
                                  User Pass
                                </MenuItem>
                        


                        </Select>
                        {errors.policyName && <FormHelperText style={{ color: "red" }} >{errors.policyName}</FormHelperText>}

                    </FormControl>
                }
            </Grid>
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

}
export default HashicorpUserCreationForm;